module.exports = __webpack_public_path__ + "media/images/riders/small/THOMAS_ESTAQUE-8470ab9096c3a16502ee315a1fec6d85.png";